import { pushDataLayer } from "@/lib/helpers/tagManager"
import { addOrderLog } from "@/lib/api/checkoutForm"

export default function trackFinalStep(
  step,
  type,
  item,
  orderSessionId = false
) {
  const data = {
    event: "form",
    step: step,
    stepName: "confirmation",
    formType: type,
    ecommerce: {
      checkout: {
        actionField: {
          step: step
        },
        items: item
      }
    }
  }

  if (orderSessionId) {
    addOrderLog(orderSessionId, "pushDataLayer", data)
  }

  pushDataLayer(data, true)
}
